"use strict";

import angular from "angular";

angular.module("nucont.accounting.managerUsers", ["nucont.shared"]);
require("./manager-users.routes");
